// CANONICAL COPY (GH #7115). src/constants/obligations/obl-compliance-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-compliance-review',
  title: 'Review compliance with IS policies and standards',
  description:
    "Conduct a review of compliance with the organisation's information security policies, rules, and standards.",
  category: 'compliance',
  scfIds: ['SCF-AUD-002'],
  cadence: { frequency: '6m', anchor: 'domain' },
  // SDEA-04: neither checker below vacuous-passes on zero tenant activity —
  // 'document-within-sla' explicitly fails when there are no matching
  // documents to check, and 'activity-log-configured' fails when
  // retentionDays is unset/0 — so 'any' still requires real evidence from
  // at least one of the two paths.
  strategy: 'any',
  fulfilmentCriteria: [
    { type: 'document-within-sla', description: 'All policy documents are reviewed within SLA' },
    {
      type: 'activity-log-configured',
      description: 'Activity logging is active with retention policy',
    },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
